import React from 'react';
import { Sun, Moon } from 'phosphor-react';
import { useTheme } from '@/context/ThemeContext';
import './ThemeToggle.css';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  return (
    <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
      {theme === 'dark'
        ? <Sun size={18} weight="fill" color="var(--tbx-gold)" />
        : <Moon size={18} weight="fill" color="var(--tbx-text-muted)" />}
    </button>
  );
};
